export default "__VITE_ASSET__ef528db8__"